import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { SearchSelectOption } from "./search-select-option";

@Component({
  selector: "app-search-combo-box",
  templateUrl: "./search-combo-box.component.html",
  styleUrls: ["./search-combo-box.component.scss"],
  standalone: false
})
export class SearchComboBoxComponent implements OnChanges {
  formCtrl: FormControl<string> = new FormControl<string>("");
  displayOptions: SearchSelectOption[] = [];
  isDropdownOpen = false;

  @Input() placeholder = "";
  @Input() selectedId: string = null;
  @Input() hasAutoComplete = false;
  @Input() options: SearchSelectOption[] = [];
  @Input() disabled = false;
  @Input() width: number;

  @Output() changedValue = new EventEmitter<string>();

  @ViewChild("searchOptInput") input: ElementRef;

  get selectValue(): string {
    if (!this.options || !this.formCtrl) {
      return null;
    }
    const opt = this.options.find((_) => _.value === this.formCtrl.value);
    return opt?.label;
  }

  get viewportHeight(): number {
    return Math.min(this.displayOptions.length * 48, 216);
  }

  get useVirtualScroll(): boolean {
    return this.displayOptions.length > 20;
  }

  get autoComplete(): string {
    return this.hasAutoComplete ? "on" : "off";
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedId || changes.validations) {
      this.formCtrl = new FormControl<string>(this.selectedId, []);
    }

    if (changes.options && this.options) {
      this.filtering();
    }

    this.disabled ? this.formCtrl.disable() : this.formCtrl.enable();
  }

  output(): void {
    if (this.disabled) {
      return;
    }

    const selectOption = this.options.find((_) => _.value === this.formCtrl.value);
    this.changedValue.emit(selectOption.value);
  }

  filtering(str: string = ""): void {
    if (!str) {
      this.displayOptions = this.options.filter(() => true);
    } else {
      const lowerStr = str.toLowerCase();
      this.displayOptions = this.options.filter((_) => _.value === null || _.label?.toLowerCase().indexOf(lowerStr) !== -1);
    }
  }

  openChange(opened: boolean): void {
    this.isDropdownOpen = opened;
    if (opened) {
      this.filtering(this.input.nativeElement.value);
      setTimeout(() => this.input.nativeElement.focus(), 0);
    } else {
      this.filtering();
    }
  }
}
